import { render } from "./TaskRulePage.vue?vue&type=template&id=3b988f91&scoped=true&ts=true"
import script from "./TaskRulePage.vue?vue&type=script&lang=ts"
export * from "./TaskRulePage.vue?vue&type=script&lang=ts"

import "./TaskRulePage.vue?vue&type=style&index=0&id=3b988f91&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b988f91"]])

export default __exports__